export const notAuthorized = () => {
	window.location.href = '/login'
	return null
}
